import { App } from "vue";
import VueApexCharts from "vue3-apexcharts";

const ApexChartsPlugin = {
    install( app: App< Element > ) {
        app.use( VueApexCharts );
        app.component( 'apexchart', VueApexCharts );
    }
}
export default ApexChartsPlugin;
